export default class ContentAccess {
	constructor ({ customer }) {
		this.customer = customer ? JSON.parse(JSON.stringify(customer)) : null;
		this.pageAccessMode = window.pageAccessMode || '';
		this.init();
	}

	init() {
		switch (true) {
			case this.pageAccessMode.includes('view_customer_only'):
				this.customerContent();
				break;

			case this.pageAccessMode.includes('view_approved_customer_only'):
				this.approvedCustomerContent();
				break;

			case this.pageAccessMode.includes('price_customer_only'):
				this.customerPrices();
				break;

			case this.pageAccessMode.includes('price_approved_customer_only'):
				this.approvedCustomerPrices();
				break;

			case this.pageAccessMode.includes('public'):
				/*this.handlePublicContent();*/
				break;

			default:
				break;
		}
	}

	customerContent () {
		if (!this.customer || this.customer.guest) {
			const { pathname } = window.location;
			const link = `/my/signin?next=${pathname}`;

			window.location.href = link;
		}
	}

	approvedCustomerContent () {
		if (!this.customer || this.customer.guest || !this.customer.is_approved) {
			const msg = document.createElement('div');
			msg.setAttribute('style', 'position: fixed; top: 0; left: 0; z-index: 9999; width: 100%; height: 100%; background: #fff; display: flex; justify-content: center; text-align: center; align-items: center; font-size: 16px;');
			msg.innerHTML = '<span><b>Sorry...</b><br>To view this page, your customer account needs to be approved.</span>';
			document.body.append(msg);
		}
	}

	customerPrices () {
		if (!this.customer || this.customer.guest) {
			this.hidePrices();
		}
	}

	approvedCustomerPrices () {
		if (!this.customer || this.customer.guest || !this.customer.is_approved) {
			this.hidePrices();
		}
	}

	hidePrices () {
		const priceRefs = document.querySelectorAll('.product-price');

		priceRefs.forEach(ref => {
			ref.remove();
		});
	}

	/*handlePublicContent() {}*/
}

function initContentAccess () {
	window.Session.get( 'Customer' ).then( customer => {
		new ContentAccess({ customer });
	});
}

document.addEventListener('[Session]:fetched', initContentAccess);
document.addEventListener('SESSION_FETCHED', initContentAccess);
